module.exports = __webpack_public_path__ + "img/partner-14.1077dc7c.png";